<script>
export default {
  name: "CompanyPreferencesForm",
  props: {
    preferences: Object,
  },
  data() {
    return {
      inputs: [
        {
          name: "certificates",
          title: "Максимальное количество файлов грамот/наград:",
          value: null,
        },
        {
          name: "certificatesFileLimit",
          title: "Максимальный размер файла грамоты/награды (МБ):",
          value: null,
        },
        {
          name: "presentations",
          title: "Максимальное количество файлов презентаций:",
          value: null,
        },
        {
          name: "presentationsFileLimit",
          title: "Общий размер файлов презентаций (Макс. 1 файл 250 МБ):",
          value: null,
        },
        {
          name: "spheres360",
          title: "Максимальное количество файлов фото 360:",
          value: null,
        },
        {
          name: "spheres360FileLimit",
          title: "Максимальный размер файла фото 360 (МБ):",
          value: null,
        },
        {
          name: "excursion",
          title: "Максимальное количество файлов экскурсий:",
          value: null,
        },
        {
          name: "excursionFileLimit",
          title: "Максимальный размер файла экскурсии (КБ):",
          value: null,
        },
        {
          name: "models",
          title: "Максимальное количество файлов 3D-моделей:",
          value: null,
        },
        {
          name: "modelsFileLimit",
          title: "Максимальный размер файла 3D-модели (МБ):",
          value: null,
        },
        {
          name: "textures",
          title: "Максимальное количество файлов текстур для одной 3D-модели:",
          value: null,
        },
        {
          name: "texturesFileLimit",
          title: "Общий размер файлов текстур для одной 3D-модели (МБ):",
          value: null,
        },
        // {
        //   name: "logos",
        //   title: "logos:",
        //   value: null,
        // },
        // {
        //   name: "logosFileLimit",
        //   title: "logos file limit:",
        //   value: null,
        // },
      ],
    }
  },
  computed: {
    getInputs() {
      return _.map(this.inputs, (item) => {
        item.value = this.preferences[item.name]
        return item
      })
    },
  },
}
</script>
